import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle } from "lucide-react";

const PaymentSuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate("/dashboard");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[var(--bg-main)] flex items-center justify-center px-6 py-12">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="bg-white card-shadow-deep border-0">
          <CardContent className="p-8 text-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="w-20 h-20 rounded-full bg-[var(--success)]/20 flex items-center justify-center mx-auto mb-6"
            >
              <CheckCircle className="w-10 h-10 text-[var(--success)]" />
            </motion.div>

            <h1 className="text-2xl font-bold text-[var(--deep-ocean)] mb-2">
              Payment Successful!
            </h1>
            <p className="text-[var(--river-stone)] mb-6">
              Welcome to FishingFanatix! Your membership is now active.
            </p>

            <Button
              onClick={() => navigate("/dashboard")}
              className="w-full btn-primary"
              data-testid="go-to-dashboard-btn"
            >
              Go to Dashboard
            </Button>

            <p className="mt-4 text-xs text-[var(--river-stone)]">
              Redirecting automatically in 5 seconds...
            </p>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default PaymentSuccessPage;
